import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Program from "../components/Program";
import HowItWorks from "../components/HowItWorks";
import Alignment from "../components/Alignment";
import Outcomes from "../components/Outcomes";
import Manifesto from "../components/Manifesto";
import Team from "../components/Team";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    const t = setTimeout(() => {
      const el = document.getElementById(target);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F9FAFB]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Program />
        <HowItWorks />
        <Alignment />
        <Outcomes />
        <Manifesto />
        <Team />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
